import IconNota from '../../Analises/IconNota';
import ContextTela from '../../../pages/DicasOtimizacao/telaContext';
import { useContext, useEffect, useState } from '@wordpress/element';
import TooltipBase from '../../Analises/TooltipBase';
import { CampoInputBase } from './CampoInputBase';
import { IoMdCheckmark, IoMdClose } from 'react-icons/io';
import CircularProgress from '@componentsNew/CircularProgress';
import EstruturaPostContext from '@pages/DicasOtimizacao/Context/EstruturaPostContext';

export function CampoInput({
  alerta,
  mensagem = '',
  valor,
  setValor,
  label,
  campoEstrutura = null,
  placeholder,
  eventoClique,
  carregando,
  objetoInterno = false,
  carregandoNota,
  desabilidato = false,
  nota,
  multilinhas = false,
  textoAuxiliar,
  textarea = false,
}) {
  const { desktop } = useContext(ContextTela);

  const [conteudoInput, setConteudoInput] = useState({
    conteudo: '',
    carregando: true
  });

  const { alterarConteudoEstrutura } = useContext(EstruturaPostContext);

  useEffect(() => {
    if (!carregando) {
      setConteudoInput({ conteudo: valorFinal(), carregando: false });
    }
  }, [nota, carregando]);


  useEffect(() => {
    console.log(conteudoInput)
    let timeoutId
    const observador = () => {
      timeoutId = setTimeout(() => {
        if (conteudoInput?.conteudo && conteudoInput?.conteudo?.trim() !== valorFinal()?.trim()) {
          setConteudoInput(prev => ({ ...prev, carregando: true }));
          alterarConteudoEstrutura(campoEstrutura, conteudoInput.conteudo);
        }
      }, 4500)
    }

    observador()

    return () => {
      clearTimeout(timeoutId)
    }
  }, [conteudoInput])

  function valorFinal() {
    return objetoInterno ? nota?.conteudo?.valor : nota?.conteudo
  }

  //TODO: mudar component input
  return (
    <div
      className={`${desktop ? 'w-5/6' : 'w-full'} justify-start items-start gap-3 inline-flex mt-4`}
    >
      {carregandoNota && (
        <div className='px-[0.125em]'>
          <CircularProgress />
        </div>
      )}

      {!carregandoNota && (
        <TooltipBase
          texto={
            alerta ? (
              alerta
            ) : (
              <div className="flex flex-col ">
                {nota?.criterios?.map((item, index) => (
                  <div key={index} className="flex flex-row items-center gap-2 ">
                    <div>
                      {item.otimizado ? (
                        <IoMdCheckmark className="w-4 h-4" />
                      ) : (
                        <IoMdClose className="w-4 h-4 pt-1" />
                      )}
                    </div>
                    <span>{item?.texto}</span>
                  </div>
                ))}
              </div>
            )
          }
          item={<IconNota nota={nota?.valor} alerta={alerta} />}
        />
      )}

      <CampoInputBase
        alerta={alerta}
        mensagem={mensagem}
        valor={!campoEstrutura || valor ? valor : conteudoInput.conteudo}
        setValor={!campoEstrutura || setValor ? setValor : e => setConteudoInput(prev => ({ ...prev, conteudo: e }))}
        label={label}
        placeholder={placeholder}
        eventoClique={eventoClique}
        carregando={!campoEstrutura ? carregando : conteudoInput.carregando}
        desabilidato={desabilidato || conteudoInput.carregando}
        nota={nota?.valor}
        multilinhas={multilinhas}
        textoAuxiliar={textoAuxiliar}
        textarea={textarea}
      />
    </div>
  );
}
